import * as React from 'react'
import { Button } from '@mobiscroll/react-latest'
import OrganizationsSearch from '../../containers/organizations/OrganizationsSearch'
import { handleRedirect } from 'src/utils'
import Plus from '../icons/organizations/Plus'
import UIMessages from 'src/utils/ui-messages'

const OrganizationsHeaderTools = (props: { path: string }) => {
  return (
    <div className='flex ml-auto items-center'>
      <div className='p1 cursor--pointer'>
        <OrganizationsSearch />
      </div>
      <div className='relative flex items-center'>
        <Button
          ariaLabel='Redirect to create organization component'
          className='mbsc-btn-with-start-icon mbsc-success-btn'
          onClick={() => handleRedirect(`${props.path}/create/organization-info`)}
        >
          {UIMessages.common.createNewOrganization}
        </Button>
        <Plus className='absolute ml2 z1' />
      </div>
    </div>
  )
}
export default OrganizationsHeaderTools



// WEBPACK FOOTER //
// ./src/components/organizations/OrganizationsHeaderTools.tsx